import { useEffect, useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import axiosInstance from "services/axiosInstance";
import * as S from "./styled";
//Components
import LayoutModal from "../../../LayoutModal";
import CreateProduct from "../CreateProducts";
//hooks
import apiRequest from "../../../../hooks/apiRequest";
import useLoading from '../../../../hooks/useLoading';
//Icons
import { Article } from "@phosphor-icons/react";
//Interface
import { IAgreement } from "Interfaces/IAgreement";
import { ICreate } from "Interfaces/ICreate";
import { Inputs } from "Interfaces/IFrame";
import { ILab } from "Interfaces/ILaboratory";
import { IMethPay } from "Interfaces/IMethodPaym";
export default function CreateRetr({
  isOpenModal,
  setModalClose,
  refreshFrames,

  setToastOpen,
  setToastData,
}: ICreate) {
  const {
    register,
    reset,
    handleSubmit,
    control,
    watch,
    setValue,
    getValues,
    resetField,
    formState: { errors },
  } = useForm<Inputs>();

  const [paymnent, setPayment] = useState<IMethPay[]>([]);
  const [agreement, setAgreement] = useState<IAgreement[]>([]);
  const [laboratory, setLaboratory] = useState<ILab[]>([]);
  const { isLoading, startLoading, stopLoading } = useLoading();

  const fetchData = async () => {
    try {
      const [responsePayment, responseAgreement, responseLab] =
        await Promise.all([
          axiosInstance.get(`payment-method`),
          axiosInstance.get(`agreement`),
          axiosInstance.get(`laboratory`),
        ]);
      setPayment(responsePayment.data);
      setAgreement(responseAgreement.data);
      setLaboratory(responseLab.data);
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  useEffect(() => {
    if (isOpenModal) {
      fetchData();
    }
  }, [isOpenModal]);

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    startLoading();
    try {
      const response = await apiRequest(`frame`, 'POST', data);
      if (response.status === 201) {
        setToastData({
          status: response.status,
          message: 'Cadastrado com sucesso!',
        });

        setToastOpen(true);
        refreshFrames();
        onClose();

      }
    } catch (error: any) {
      setToastData({
        status: error?.response?.status || 500,
        message: error.message || 'Erro inesperado',
      });

      setToastOpen(true);
    } finally {
      stopLoading();
    }
  };

  const onClose = () => {
    setModalClose();
    reset();
  };

  const CalculateValues = () => {
    const qtd = watch("amount") || 0; // Certifique-se de que o valor é um número
    const valueCompra = watch("purchase_value") || 0;
    const valueVenda = Number(watch("price") || 0); // Valor da venda
    const lucro = watch("profit") || 0;

    // Verificar se os campos obrigatórios estão preenchidos
    if (!qtd || !valueCompra) {
      alert(
        "Para realizar o cálculo, é necessário informar a quantidade e o valor da compra!"
      );
      return; // Interrompe a execução caso os valores sejam inválidos
    }

    // Calcular o resultado base
    const result = valueCompra / qtd;

    // Caso 1: Calcular o lucro
    if (qtd && valueCompra && valueVenda && !lucro) {
      const calculatedLucro = ((valueVenda - result) / result) * 100;
      setValue("profit", calculatedLucro); // Atualiza o campo de lucro
      return;
    }

    // Calcular o resultado com lucro
    const resultLucro = result + (result * lucro) / 100;

    setValue("price", resultLucro.toString());
  };

  if (isOpenModal) {
    return (
      <LayoutModal
        statusLoad={isLoading}
        title="Registrar Venda Manual"
        subTitle="Cadastre uma nova venda em sua base de dados."
        setModalClose={onClose}
        submiteModal={handleSubmit(onSubmit)}

        nameIconMinimize={'Registrar Venda Manual'}
        setMaximizeModal={fetchData}
      >
        <S.Container>
          <S.InforHead>
            <span>
              Modo Manual:
            </span>
            Digite livremente os produtos e preços. Ideal para vendas retroativas ou produtos não cadastrados.
          </S.InforHead>

          {/* Inicio dados da venda */}
          <S.FormsSection>
            <S.HeaderSection>
              <p>
                <Article size={18} />
                Dados da Venda
              </p>
            </S.HeaderSection>

            <S.SeparateDiv>
              <S.FormInput>
                <S.Label>
                  Número da venda
                  <span>*</span>
                </S.Label>
                <S.Input
                  placeholder="Informe o código da armação"
                  type="text"
                  {...register("code", { required: true })}
                />
                {errors.code && <S.InforErro>Campo Obrigatório</S.InforErro>}
              </S.FormInput>

              <S.FormInput>
                <S.Label>Número da O.S.</S.Label>
                <S.Input type="text" placeholder="Informe a cor" {...register("color")} />
              </S.FormInput>

              <S.FormInput>
                <S.Label>
                  Data da venda
                </S.Label>
                <S.Input
                  placeholder="Informe o tamanho"
                  type="date"
                  {...register("size")}
                />
                {errors.size && <S.InforErro>Campo Obrigatório</S.InforErro>}
              </S.FormInput>
            </S.SeparateDiv>

            <S.SeparateDiv>
              <S.FormInput>
                <S.Label>
                  Consultor(a)
                </S.Label>
                <S.Input
                  placeholder="Informe a ponta"
                  type="text"
                  {...register("bridge")}
                />
                {errors.bridge && <S.InforErro>Campo Obrigatório</S.InforErro>}
              </S.FormInput>

              <S.FormInput>
                <S.Label>
                  Laboratório
                </S.Label>
                <S.Select {...register("material_id")}>
                  <option value="" disabled selected hidden>
                    Selecione
                  </option>
                  {laboratory.map((val) => {
                    return <option value={val.id}>{val.laboratory}</option>;
                  })}
                </S.Select>
                {errors.material_id && (
                  <S.InforErro>Campo Obrigatório</S.InforErro>
                )}
              </S.FormInput>

              <S.FormInput>
                <S.Label>
                  Origem
                </S.Label>
                <S.Input
                  placeholder="Informe a haste"
                  type="text"
                  {...register("haste")}
                />
                {errors.haste && <S.InforErro>Campo Obrigatório</S.InforErro>}
              </S.FormInput>
            </S.SeparateDiv>
          </S.FormsSection>
          {/* Fim dados da venda */}

          {/* Inicio informações do cliente */}
          <S.FormsSection>
            <S.HeaderSection>
              <p>
                <Article size={18} />
                Informações do Cliente
              </p>
            </S.HeaderSection>

            <S.SeparateDiv>
              <S.FormInput>
                <S.Label>
                  Paciente
                  <span>*</span>
                </S.Label>
                <S.Input
                  placeholder="Informe o código da armação"
                  type="text"
                  {...register("code", { required: true })}
                />
                {errors.code && <S.InforErro>Campo Obrigatório</S.InforErro>}
              </S.FormInput>

              <S.FormInput>
                <S.Label>
                  Convênio
                </S.Label>
                <S.Select {...register("material_id")}>
                  <option value="" disabled selected hidden>
                    Selecione
                  </option>
                  {agreement.map((val) => {
                    return <option value={val.id}>{val.agreement}</option>;
                  })}
                </S.Select>
                {errors.material_id && (
                  <S.InforErro>Campo Obrigatório</S.InforErro>
                )}
              </S.FormInput>
            </S.SeparateDiv>

            <S.SeparateDiv>
              <S.FormInput>
                <S.Label>
                  CPF
                  <span>*</span>
                </S.Label>
                <S.Input
                  placeholder="Informe o código da armação"
                  type="text"
                  {...register("code", { required: true })}
                />
                {errors.code && <S.InforErro>Campo Obrigatório</S.InforErro>}
              </S.FormInput>
              <S.FormInput>
                <S.Label>
                  RG
                  <span>*</span>
                </S.Label>
                <S.Input
                  placeholder="Informe o código da armação"
                  type="text"
                  {...register("code", { required: true })}
                />
                {errors.code && <S.InforErro>Campo Obrigatório</S.InforErro>}
              </S.FormInput>

              <S.FormInput>
                <S.Label>
                  Contato
                  <span>*</span>
                </S.Label>
                <S.Input
                  placeholder="Informe o código da armação"
                  type="text"
                  {...register("code", { required: true })}
                />
                {errors.code && <S.InforErro>Campo Obrigatório</S.InforErro>}
              </S.FormInput>
            </S.SeparateDiv>

            <S.FormInput>
              <S.Label>
                Endereço
                <span>*</span>
              </S.Label>
              <S.Input
                placeholder="Informe o código da armação"
                type="text"
                {...register("code", { required: true })}
              />
              {errors.code && <S.InforErro>Campo Obrigatório</S.InforErro>}
            </S.FormInput>
          </S.FormsSection>
          {/* Fim informações do cliente */}

          {/* Incio Produtos */}
          <S.FormsSection>
            <S.HeaderSection>
              <p>
                <Article size={18} />
                Produtos
              </p>
            </S.HeaderSection>

            <CreateProduct
              control={control}
              errors={errors}
              getValues={getValues}
              register={register}
              reset={reset}
              resetField={resetField}
              setValue={setValue}
              watch={watch}
            />
          </S.FormsSection>
          {/* Fim Produtos */}

          {/* Incio forma de pagamento */}
          <S.FormsSection>
            <S.HeaderSection>
              <p>
                <Article size={18} />
                Forma de Pagamento
              </p>
            </S.HeaderSection>

            <S.SeparateDiv>
              <S.FormInput>
                <S.Label>
                  Pagamento
                </S.Label>
                <S.Select {...register("material_id")}>
                  <option value="" disabled selected hidden>
                    Selecione
                  </option>
                  {paymnent.map((val) => {
                    return <option value={val.id}>{val.payment_method}</option>;
                  })}
                </S.Select>
                {errors.material_id && (
                  <S.InforErro>Campo Obrigatório</S.InforErro>
                )}
              </S.FormInput>
            </S.SeparateDiv>
          </S.FormsSection>
          {/* Fim forma de pagamento */}
        </S.Container>
      </LayoutModal>
    );
  }
  return null;
}
